
import { TierItem } from "../pages/components/tierList";

export const nationalStatesList: TierItem[] = [
    { name: "Alabama", tier: "B" },
    { name: "Alaska", tier: "NA" },
    { name: "Arizona", tier: "A" },
    { name: "Arkansas", tier: "B" },
    { name: "California", tier: "A" },
    { name: "Colorado", tier: "B" },
    { name: "Connecticut", tier: "C" },
    { name: "Delaware", tier: "F" },
    { name: "Florida", tier: "B" },
    { name: "Georgia", tier: "B" },
    { name: "Hawaii", tier: "NA" },
    { name: "Idaho", tier: "B" },
    { name: "Illinois", tier: "B" },
    { name: "Indiana", tier: "C" },
    { name: "Iowa", tier: "F" },
    { name: "Kansas", tier: "C" },
    { name: "Kentucky", tier: "A" },
    { name: "Louisiana", tier: "S" },
    { name: "Maine", tier: "B" },
    { name: "Maryland", tier: "B" },
    { name: "Massachusetts", tier: "B" },
    { name: "Michigan", tier: "C" },
    { name: "Minnesota", tier: "B" },
    { name: "Mississippi", tier: "C" },
    { name: "Missouri", tier: "B" },
    { name: "Montana", tier: "B" },
    { name: "Nebraska", tier: "F" },
    { name: "Nevada", tier: "C" },
    { name: "New Hampshire", tier: "C" },
    { name: "New Jersey", tier: "NA" },
    { name: "New Mexico", tier: "S" },
    { name: "New York", tier: "NA" },
    { name: "North Carolina", tier: "B" },
    { name: "North Dakota", tier: "C" },
    { name: "Ohio", tier: "A" },
    { name: "Oklahoma", tier: "C" },
    { name: "Oregon", tier: "A" },
    { name: "Pennsylvania", tier: "A" },
    { name: "Rhode Island", tier: "C" },
    { name: "South Carolina", tier: "NA" },
    { name: "South Dakota", tier: "C" },
    { name: "Tennessee", tier: "B" },
    { name: "Texas", tier: "C" },
    { name: "Utah", tier: "S" },
    { name: "Vermont", tier: "B" },
    { name: "Virginia", tier: "B" },
    { name: "Washington", tier: "S" },
    { name: "West Virginia", tier: "A" },
    { name: "Wisconsin", tier: "A" },
    { name: "Wyoming", tier: "C" },
];
